// 获取路径
export function getPathFromUrl(input) {
    if (!input || typeof input !== "string") return "";
    let urlStr = input.trim();
    // 1. 去掉多余前缀的斜杠
    urlStr = urlStr.replace(/^\/+/, "");
    // 2. 匹配疑似 URL 的字符串
    const urlMatch = urlStr.match(/(https?:\/\/[^ \n]+)/i);
    if (urlMatch) {
        try {
            const url = new URL(urlMatch[1]);
            return url.pathname + url.search + url.hash;
        } catch {
        }
    }
    // 3. fallback：返回原始路径（保留一个开头斜杠）
    return input.startsWith("/") ? input : `/${input}`;
}

// 获取正常URL
export function getNormalUrl(input) {
    if (!input || typeof input !== "string" || input.trim() === "") {
        return "/";
    }
    let str = input.trim();
    // 去掉前面所有斜杠，比如 //https://... 或 /////path
    str = str.replace(/^\/+/, "");
    const hasDomain = /^https?:\/\//i.test(str);
    if (hasDomain) {
        try {
            const url = new URL(str);
            return url.origin + url.pathname + url.search + url.hash;
        } catch {
            if (str === "https://" || str === "http://") {
                return str;
            } else {
                return "/";
            }
        }
    } else {
        return "/" + str.replace(/^\/+/, "");
    }
}